// frontend/src/components/responsive-fixes/FooterMobile.tsx
//
// Phone/phablet-friendly footer right-cluster (audit M1). Replaces
// the desktop 5-chip info row (Time / Date / Telemetry / Node Status /
// VAT) with a compacted "time + system-online dot" pair so the fixed
// footer doesn't wrap into a 60px tall bar at <640px viewports.
//
// Mounted by Layout.tsx conditionally on responsive.isPhone — the
// existing inline desktop chips array is hidden via display:none
// (already in PR #72) and this component is rendered alongside.
//
// Zero edits to majestic.css / layout.css / tokens.css.

import React from "react";
import { BRAND } from "../../branding";

interface Props {
  /** Current time (mirrored from Layout.tsx's existing setInterval). */
  time: Date;
  /** Optional VAT label. Defaults to "VAT 5%". */
  vatLabel?: string;
}

function formatTimeShort(d: Date): string {
  return d.toLocaleTimeString("en-AE", {
    hour: "2-digit",
    minute: "2-digit",
    timeZone: BRAND.timezone || "Asia/Dubai",
    hour12: false,
  });
}

const FooterMobile: React.FC<Props> = ({ time, vatLabel = "VAT 5%" }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontFamily: BRAND.fontFamily,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          fontSize: 11,
          fontWeight: 600,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          color: "#bdb2ff",
        }}
      >
        <span className="material-symbols-outlined" style={{ fontSize: 13 }}>
          schedule
        </span>
        {formatTimeShort(time)}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 5,
          background: "rgba(189,178,255,0.06)",
          borderRadius: 6,
          padding: "3px 8px",
        }}
      >
        <span
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: "#bdb2ff",
            letterSpacing: "0.05em",
          }}
        >
          {vatLabel}
        </span>
      </div>
    </div>
  );
};

export default FooterMobile;
